import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import CriSection from "../../components/CriSection";
import BeePhoto from "../../assets/images/bees/bombus_impatiens.jpg";

const BeeSection = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/research/bees");
  };

  return (
    <CriSection>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "28px",
                md: "36px",
              },
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Bees of the Southern Lake Michigan Region
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Laura Rericha-Anchor and CRI research associates Robert Jean and
            Michael Arduser continue to work on the Bees of the Southern Lake
            Michigan Region monograph, a work discussing the regional
            distributions of 513 bee species identified by the authors. The
            paper also highlights the phenologies, habitat preferences, faunal
            associations, and life histories of the region’s bees.
          </Typography>

          <Button
            onClick={handleLearnMore}
            variant="contained"
            sx={{
              marginTop: {
                xs: "24px",
                md: "12px",
              },
              padding: "8px 36px",
            }}
          >
            Learn More
          </Button>
        </Box>

        <Box
          sx={{
            marginLeft: {
              xs: 0,
              md: "36px",
            },
            marginTop: {
              xs: "24px",
              md: 0,
            },
            width: {
              xs: "100%",
              md: "400px",
            },
          }}
        >
          <img
            src={BeePhoto}
            alt="Bee on flower"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </CriSection>
  );
};

export default BeeSection;
